import React, { FunctionComponent } from 'react';

import styles from './UserInfo.module.scss';
import { Grid, IconButton } from '@material-ui/core';
import AvatarCell from '../Tables/Cells/AvatarCell';
import { getTimeDifference } from 'app/utils/get-difference-times';
import { MarkedImportantIcon, RestartIcon } from 'app/assets/images/icons';
import { nFormatter } from 'app/utils/numbersFormater';
import { _t } from 'app/utils/i18n';
import { parseMentions } from 'app/utils/pasreMentions';
import { checkTranslated } from 'app/utils/helpers';

import { useModal } from 'app/context/Modal';
import { useHistory, useParams } from 'react-router-dom';
import LastRegrabOn from '../LastRegrabOn/LastRegrabOn';
import { useHandleNavigateInfluencerOrEntity } from 'app/utils/check-influencer-user';

interface Props {
  data: any;
  openModalToAddInfluencer?: (url: string, name: string) => void;
  handleInfluencer?: (influencer?: object) => void;
  withActionRow?: boolean;
  regrabMutation?: any;
  addInfluncerMutateAsync?: any;
}

const UserInfo: FunctionComponent<Props> = ({
  data,
  openModalToAddInfluencer,
  handleInfluencer,
  withActionRow,
  addInfluncerMutateAsync,
  regrabMutation,
}) => {
  const modal = useModal();
  const history = useHistory();
  const params = useParams<any>();
  const [handleNavigateInfluencerOrEntity] =
    useHandleNavigateInfluencerOrEntity();

  return (
    <div className={styles.UserInfo}>
      <Grid
        item
        className={styles.PersonalInfo}
        sm={12}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          data?.influencer?.influencer_id === 0
            ? openModalToAddInfluencer?.(data?.username, data?.influencer?.url)
            : handleNavigateInfluencerOrEntity(data?.influencer);
        }}
      >
        <AvatarCell
          img={data?.influencer?.image_url || data?.influencer?.image}
          rounded
        />
        <div className={styles.PersonalName}>
          <div
            className={withActionRow ? styles.name : ''}
            style={{
              justifyContent: regrabMutation ? 'space-between' : 'unset',
            }}
          >
            <span>
              {data?.influencer?.name?.original?.length
                ? data?.influencer?.name?.original
                : data?.username}
              {!!data?.influencer?.is_profile_verified ||
                (!!data?.is_profile_verified && (
                  <MarkedImportantIcon style={{ marginInlineStart: '5px' }} />
                ))}
            </span>
            {regrabMutation && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  regrabMutation.mutateAsync({
                    id: data?.id,
                  });
                }}
                className={styles.regrabAction}
              >
                <LastRegrabOn time={data?.last_grabbed_on} />
              </IconButton>
            )}
          </div>
          {!withActionRow && (
            <p dir="auto">
              <span>@{data?.username}</span>.
              <span>
                {data?.published_at?.length
                  ? getTimeDifference(data?.published_at)
                  : ''}
              </span>
            </p>
          )}
          {withActionRow && (
            <div className={styles.commentText} dir="auto">
              {parseMentions(
                checkTranslated(
                  data?.text?.original || data?.caption?.original,
                  data?.text?.arabic || data?.caption?.original,
                ),
                (url, username) => openModalToAddInfluencer?.(url, username),
                (data) => handleNavigateInfluencerOrEntity(data?.influencer),
                data?.post_mentions,
              )}
            </div>
          )}
          {withActionRow && (
            <div className={styles.actionRow}>
              <span>{data?.time}</span>
              <span>{`${nFormatter(data?.likes_count)} ${_t('posts:like')}`}</span>
            </div>
          )}
        </div>
      </Grid>
    </div>
  );
};

export default UserInfo;
